import { ContainerModule } from 'inversify';
import FileDownloadLinkGenerator from '@framework/api/downloadFile/FileDownloadLinkGenerator';
import { type IDispatcher } from '@dm-portal/json-rpc-dispatcher';
import RpcDITypes from '@dm-portal/json-rpc-dispatcher/DITypes';
import { type ISocketClient } from '@drs/socket-client';
import SocketDITypes from '@drs/socket-client/DITypes';
import DITypes from './types';
import type { IFileDownloadLinkGenerator } from './interfaces';

export const FileDownloadLinkGeneratorModule = new ContainerModule(({ bind }) => {
  bind<IFileDownloadLinkGenerator>(DITypes.FileDownloadLinkGenerator)
    .toDynamicValue(({ get }) => new FileDownloadLinkGenerator(
      get<IDispatcher>(RpcDITypes.JsonRpcDispatcher),
      get<ISocketClient>(SocketDITypes.SocketClient),
    ))
    .inSingletonScope();
});
